module.exports = __webpack_public_path__ + "staticVue/img/2.350434fe.png";